module.exports = __webpack_public_path__ + "static/logo-6a06a6e573cd3ca6d0fa4f9b8064b300.png";